import React from 'react';

/**
 * System-tab entry point for Output Reports (review #8).
 *
 * Cross-user browsing by raw party ID is intentionally not offered here — admins
 * don't work in party IDs, and that free-text path was the route that leaked one
 * user's reports into another's results. View a recipient's reports from their
 * user profile page instead. If genuine cross-user search is added later it must
 * use a user-name dropdown (resolving to party IDs behind the scenes), not a raw
 * party-ID box.
 */
const OutputReportAdminPlaceholder = () => (
    <div style={{ padding: '20px' }}>
        <h2>Output Reports</h2>
        <p>
            To view the reports transferred to a recipient, open that user's profile
            page and use the <strong>Output Reports</strong> section there.
        </p>
        <p style={{ color: '#888' }}>
            Searching across all users from here may be added in future.
        </p>
    </div>
);

export default OutputReportAdminPlaceholder;
